import React from 'react';
import FormattedBox from '../../components/FormattedBox'
import * as Filters from '../../helpers/Filters'
import * as Formatting from 'fw/misc/Formatting'
import * as Parsing from 'fw/misc/Parsing'

class PercentageBox extends React.Component {

	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { this._input.getValue(); }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }
	validate = () => { 
        var msg = this._input.validate(); 
        
        if (msg == null){
            const val = this._input.getValue();

            if (val !== ''){
                const intVal = parseInt(val, 0);

                if (intVal > this.props.maxValue)
                    msg = "Invalid value (max " + this.props.maxValue + ").";
                else if (intVal < this.props.minValue)
                    msg = "Invalid value (min " + this.props.maxValue + ").";
            }
        }

        return msg;
    }

	// Private
	_format = (value) => {
		return Formatting.formatPrct(value, this.props.precision);
	}

	_parse = (value) => {
		if (this.props.max && parseFloat(value) > parseFloat(this.props.max))
			value = this.props.max;

		return Parsing.parsePrct(value);
	}

	_filter = (key) => {
		return Filters.positiveNumbersOnly(key) && key !== ",";
	}

	// React
	render() {
		const props = {
			...this.props,
			formatter: this._format,
			parser: this._parse,
			filter: this._filter,
			className: this.props.className + " text-right"
		}

		return (<FormattedBox {...props} ref={(input) => this._input = input} />)
	}
}

export default PercentageBox;

// Mark this as a form component
PercentageBox.defaultProps = {
	formControl: true,
	managed: false,
	maxLength: 20,
    precision: 2,
    maxValue: 100, 
    minValue: 0
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/percentageBox/PercentageBox.js